// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartTotalStyles } from "@guestsupply/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitCartTotal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { RadioStyle } from "@insite/mobius/Radio";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

cartTotalStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-bottom: 16px;
    `,
};
cartTotalStyles.cartTotalGridItem = { width: 12 };
cartTotalStyles.buttonsGridItem = {
    width: 12,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        display: none;
                    `,
                ],
                "max",
            )}
        flex-direction: column;
    `,
};
cartTotalStyles.hasInsufficientInventoryGridItem = { width: 12 };
cartTotalStyles.availabilityErrorMessageText = {
    color: "danger",
    css: css`
        margin-top: 5px;
        margin-bottom: 15px;
    `,
};
cartTotalStyles.placeOrderErrorMessageGridItem = { width: 12 };
cartTotalStyles.placeOrderErrorMessageText = {
    color: "danger",
    css: css`
        margin-top: 5px;
        margin-bottom: 15px;
    `,
};
cartTotalStyles.invalidEditableAddressErrorMessageGridItem = { width: 12 };
cartTotalStyles.invalidEditableAddressErrorMessageText = {
    color: "danger",
    css: css`
        margin-top: 5px;
        margin-bottom: 15px;
    `,
};
cartTotalStyles.invalidAddressErrorMessageGridItem = { width: 12 };
cartTotalStyles.invalidAddressErrorMessageText = {
    color: "danger",
    css: css`
        margin-top: 5px;
        margin-bottom: 15px;
    `,
};
cartTotalStyles.invalidPriceErrorMessageGridItem = { width: 12 };
cartTotalStyles.invalidPriceErrorMessageText = {
    color: "danger",
    css: css`
        margin-top: 5px;
        margin-bottom: 15px;
    `,
};
cartTotalStyles.placeOrderButton = {
    variant: "primary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        width: 100%;
                    `,
                ],
                "min",
            )}
    `,
};
cartTotalStyles.submitForApprovalButton = {
    variant: "primary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        width: 100%;
                    `,
                ],
                "min",
            )}
    `,
};
cartTotalStyles.defaultFulfillmentMethodRadioGroup = {
    css: css`
        display: block;
        ${RadioStyle} {
            display: inline-block;
            margin-right: 1em;
            & + ${RadioStyle} {
                margin-top: 0;
            }
        }
    `,
};
cartTotalStyles.backButton = {
    variant: "secondary",
    css: css`
        width: 100%;
    `,
};
cartTotalStyles.tooltipStyles = {
    cssOverrides: {
        tooltipClickable: css`
            display: flex;
            margin-left: 0;
        `,
    },
};
cartTotalStyles.notifyStyles = {
    css: css`
        margin: 12px 0 0;
        min-width: initial;
    `,
};
cartTotalStyles.buttonsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};
cartTotalStyles.notifyWrapper = {
    css: css`
        &:empty {
            display: none;
        }
    `,
};
